import { GameController } from '@/components/game/GameController';
import { FogBackground } from '@/components/game/FogBackground';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

const LoupGarou = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <Helmet>
        <title>Loup-Garou IA - Jeu de société animé par Intelligence Artificielle</title>
        <meta 
          name="description" 
          content="Jouez au Loup-Garou sans animateur ! IA narrative vocale, distribution automatique des rôles, votes et phases gérés. 4-12 joueurs, gratuit, sans compte." 
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0a0e17" />
        <link rel="manifest" href="/manifest.json" />
      </Helmet>
      
      <main className="relative min-h-screen overflow-hidden">
        {/* Back button */}
        <Link 
          to="/"
          className="absolute top-4 left-4 z-50 flex items-center gap-2 px-3 py-2 rounded-lg bg-background/50 backdrop-blur-sm border border-border/50 text-muted-foreground hover:text-foreground hover:bg-background/70 transition-all"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">{t('nav.back')}</span>
        </Link>
        
        <FogBackground />
        <GameController />
      </main>
    </>
  );
};

export default LoupGarou;
